var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.5 8.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.5.5V7a.5.5,0,0,1-1,0V1.71L.85,8.35A.47.47,0,0,1,.5,8.5a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7L6.79,1H1.5A.5.5,0,0,1,1,.5.5.5,0,0,1,1.5,0H8a.41.41,0,0,1,.19,0,.51.51,0,0,1,.27.27A.41.41,0,0,1,8.5.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtLink);
export default __webpack_public_path__ + "static/media/ext-link.0c6aa1e780094d3f2a64e4e98fa19177.svg";
export { ForwardRef as ReactComponent };